<template>
    <div v-if="wave_order" class="ocean" :class="wave_order" id="ocean-waves">
      <div class="wave"></div>
      <div class="wave"></div>
      <div class="wave"></div>
    </div>
</template>

<script>

export default {
  name: 'WaveAnimation',
  props: ['wave_order']
}


</script>